import { render, staticRenderFns } from "./TabelaCadastros.vue?vue&type=template&id=ca9a7016&scoped=true"
import script from "./TabelaCadastros.vue?vue&type=script&lang=js"
export * from "./TabelaCadastros.vue?vue&type=script&lang=js"
import style0 from "./TabelaCadastros.vue?vue&type=style&index=0&id=ca9a7016&prod&lang=scss&scoped=true"
import style1 from "./TabelaCadastros.vue?vue&type=style&index=1&id=ca9a7016&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9a7016",
  null
  
)

export default component.exports